import { Link } from '@tanstack/react-router';

import { Button } from '@/shared/components/shadcn/button';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';

export function NoSavedQueries() {
  const { workspaceId } = useWorkspaceId();

  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-zinc-900">No saved queries</h3>
        <p className="mt-2 mb-10 text-sm text-zinc-500">
          Create your first query to start analyzing social media data
        </p>
        <Button asChild>
          <Link to="/workspace/$workspaceId/create-new" params={{ workspaceId }}>
            Create new query
          </Link>
        </Button>
      </div>
    </div>
  );
}
